import React from 'react';
import LazyComponent from '../components/common/LazyComponent';

const Page404 = React.lazy(() => import('../components/Page404'));

const NotFoundView: React.FC = () => {
  return (
    <div className="container mt-3">
      <LazyComponent>
        <Page404 />
      </LazyComponent>
    </div>
  );
};

export default NotFoundView; 